@if (hasProjectedMenuItems()) {
  <pu-expansion-panel
    #panel="pu-expansion-panel"
    class="pu-expansion-panel"
    renderMode="eager"
    hideToggle
    [opened]="isActive() && !isDisabled()"
  >
    <button
      class="menu-item"
      puButton
      uiType="quinary"
      (click)="panel.toggle()"
    >
      @if (!isCollapsed()) {
        <mat-icon
          class="dropdown-icon"
          [class.dropdown-icon_expanded]="panel.expanded"
          svgIcon="chevron-right"
        />
      }

      <ng-container *ngTemplateOutlet="menuItemContent"/>
    </button>

    <div
      class="nested-menu-items"
      *puExpansionPanelContent
    >
      <ng-content/>
    </div>
  </pu-expansion-panel>
} @else {
  <ng-container *ngTemplateOutlet="menuItem"/>
}

<ng-template #menuItem>
  @if (link()) {
    <a
      puButton
      uiType="quinary"
      class="menu-item"
      [routerLink]="link()"
      routerLinkActive
    >
      <ng-container *ngTemplateOutlet="menuItemContent"/>
    </a>
  } @else {
    <button
      puButton
      uiType="quinary"
      type="button"
      class="menu-item"
    >
      <ng-container *ngTemplateOutlet="menuItemContent"/>
    </button>
  }
</ng-template>


<ng-template #menuItemContent>
  @if (icon(); as icon) {
    <mat-icon [svgIcon]="icon"/>
  }
  {{ label() }}
</ng-template>
